<template>
  <v-card class="card-quote mt-5" elevation="0" v-if="projects.length > 1">
    <v-card-text>
      <v-row class="px-5">
        <v-col cols="12" style="color: var(--v-darkblue-base); font-weight: bold; font-size: 16px;">
          <!-- <v-img src="img/icons/quote_projects.png" width="107" contain></v-img> -->
          <div
            class="d-flex flex-row align-center">
            <v-sheet
              color="title-icon"
              class="d-flex justify-center align-center rounded-circle"
              height="38"
              width="38">
              <v-icon color="title-icon-background" size="20">fas fa-handshake</v-icon>
            </v-sheet>
            <span
              class="title-foreground--text font-weight-medium ml-2">
              Projetos
            </span>
          </div>
        </v-col>
        <v-col cols="12" md="2" v-for="(project, index) in projects" :key="index">
          <v-row>
            <v-col class="d-flex justify-center" cols="12" v-if="project.xipp_logo">
              <v-img class="mr-5" :src="`data:application/octet-stream;base64,${project.xipp_logo}`" height="50" contain></v-img>
            </v-col>
            <v-col class="d-flex justify-center" cols="12" v-else>
              <p class="pb-0 mb-0 d-flex align-center font-weight-bold switch-title">{{project.name}}</p>
            </v-col>
            <v-col class="pt-0 mt-0 d-flex justify-center" cols="12">
              <v-switch
                :readonly="iReadOnly"
                v-model="projectSelected"
                :value="project.id"
                class="py-0 my-0 switch switch-base">
              </v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapMutations} from "vuex";
import StudyConfigurationService from "@/services/odoo/StudyConfigurationService";

export default {
  name: 'projectConfigurations',
  data: () => ({
    iReadOnly: false,
    userId: 0,
    personType: 'PJ',
    projects: [],
    projectSelected: [],
  }),
  props: {
    city: {
      type: Object,
    }
  },
  watch: {
    city(newValue) {
      if(newValue) {
        this.loadProjectsByFilters(newValue);
      } else {
        this.projects = [];
        this.projectSelected = [];
      }
    },
    projectSelected(newValue) {
      if(newValue && newValue.length > 1) {
        this.projectSelected = [];
        this.projectSelected.push(newValue[1]);
      }
      this.saveProjectSelected();
    }
  },
  methods: {
    ...mapMutations(['showmsg', 'setDialogLoading']),
    async loadProjectsByFilters(city) {
      this.setDialogLoading(true);
      
      if(city) {
        const params = new URLSearchParams();
        params.append('cityId', city.id);
        params.append('personType', this.personType);
        params.append('userId', this.userId);
        
        await this._studyConfigurationService.findByCity(params)
          .then(response => {
            if(response && response.data) {
              this.projects = response.data;
              if(this.projects.length === 1) {
                this.projectSelected.push(this.projects[0].id);
              }
              this.$emit('emptyProjects', false);
            } else {
              this.$emit('emptyProjects', true);
            }
          })
          .catch((error) => {
            this.clearFields();
            if(error && error.response && error.response.status === 400) {
              this.showmsg({text: error.response.data.message, type: 'error'})
            } else {
              this.$emit('emptyProjects', true);
            }
          });
      }

      this.setDialogLoading(false);
    },
    saveProjectSelected() {
      this.$emit('selectProject', this.projectSelected && this.projectSelected.length ? this.projectSelected[0] : null)
    },
    clearFields() {
      this.projects = [];
      this.projectSelected = [];
    },
    reloadDataFromSessionStorage() {
      const key = 'quoteDataObj';
      if (sessionStorage.getItem(key)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(key)));
        
        if(quoteData && quoteData.projectObj && quoteData.projectObj.id) {
          this.projectSelected.push(quoteData.projectObj.id);
        }
      }
    }
  },
  beforeCreate() {
    this._studyConfigurationService = new StudyConfigurationService();
  },
  created() {
    this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');
    this.reloadDataFromSessionStorage();
  },
};
</script>

<style scoped>

.switch-title{
  height: 50px;
  font-size: 16px;
}

.switch {
  height: 40px;
}

</style>
